import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Monitor } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TEXT = [
  ["endgeraet", "Endgerät (PC / Laptop / Tablet / Smartphone)", "z. B. Laptop Lenovo"],
  ["betriebssystem", "Betriebssystem / Browser", "z. B. Windows 11, Chrome"],
  ["internet", "Internetverbindung (Art, Speedtest)", "z. B. WLAN, 50 Mbit/s"],
  ["geprueft_von", "Geprüft von", "Name"],
];

const JaNein = ({ feld, label, value, onChange }) => (
  <div className="space-y-1">
    <Label className="text-xs">{label}</Label>
    <div className="flex gap-2">
      {[["ja", true], ["nein", false]].map(([t, v]) => (
        <Button key={t} type="button" size="sm" variant={value === v ? "default" : "outline"}
          onClick={() => onChange(feld, v)} data-testid={`technik-${feld}-${t}`}>{t}</Button>
      ))}
    </div>
  </div>
);

export const TechnikCheck = ({ teilnehmerId, initial, onSaved }) => {
  const [tc, setTc] = useState(initial || {});
  const [saving, setSaving] = useState(false);
  useEffect(() => { setTc(initial || {}); }, [teilnehmerId, initial]);
  const set = (k, v) => setTc((p) => ({ ...p, [k]: v }));
  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/teilnehmer/${teilnehmerId}/technik-check`, tc);
      toast.success("Technik-Check gespeichert – erscheint in der Erstgespräch-Checkliste");
      onSaved?.();
    } catch (e) {
      toast.error("Technik-Check konnte nicht gespeichert werden");
    } finally {
      setSaving(false);
    }
  };
  return (
    <Card className="border-l-4 border-l-sky-500" data-testid="technik-check-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><Monitor size={18} className="text-sky-600" /> Technik-Check (vor Maßnahmebeginn)</CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {TEXT.map(([k, l, ph]) => (
          <div key={k} className="space-y-1">
            <Label className="text-xs">{l}</Label>
            <Input value={tc[k] || ""} placeholder={ph} onChange={(e) => set(k, e.target.value)} data-testid={`technik-${k}`} />
          </div>
        ))}
        <JaNein feld="kamera" label="Kamera funktionsfähig" value={tc.kamera} onChange={set} />
        <JaNein feld="mikrofon" label="Mikrofon / Headset funktionsfähig" value={tc.mikrofon} onChange={set} />
        <div className="space-y-1">
          <Label className="text-xs">Zoom-Testverbindung am</Label>
          <Input type="date" value={(tc.testverbindung_am || "").slice(0, 10)} onChange={(e) => set("testverbindung_am", e.target.value)} data-testid="technik-testverbindung_am" />
        </div>
        <div className="flex items-end">
          <Button onClick={save} disabled={saving} data-testid="technik-check-speichern">{saving ? "Speichert…" : "Technik-Check speichern"}</Button>
        </div>
      </CardContent>
    </Card>
  );
};
